import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/d79bif32hsar0k5m0li0";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">
            Cotización Gratis
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Solicita tu cotización
            <span className="text-teal-600"> personalizada</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Cuéntanos sobre tu espacio y te enviamos una cotización sin compromiso en menos de 24 horas.
          </p>
        </div>

        {/* Form */}
        {submitted ? (
          <div className="flex flex-col items-center justify-center text-center py-20 bg-teal-50 rounded-2xl">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-full mb-4">
              <i className="ri-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">¡Solicitud enviada!</h3>
            <p className="text-gray-500 max-w-sm text-sm leading-relaxed">
              Gracias por contactarnos. Te responderemos con tu cotización personalizada en menos de 24 horas.
            </p>
            <button
              onClick={() => { setSubmitted(false); setCharCount(0); }}
              className="mt-6 text-teal-600 text-sm font-semibold hover:underline cursor-pointer whitespace-nowrap"
            >
              Enviar otra solicitud
            </button>
          </div>
        ) : (
          <form
            data-readdy-form
            id="quote-form"
            onSubmit={handleSubmit}
            className="bg-gray-50 rounded-2xl p-6 md:p-10 flex flex-col gap-5"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Nombre completo *</label>
                <input
                  type="text"
                  name="nombre"
                  required
                  placeholder="Tu nombre"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Teléfono *</label>
                <input
                  type="tel"
                  name="telefono"
                  required
                  placeholder="(123) 456-7890"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Correo electrónico</label>
              <input
                type="email"
                name="email"
                placeholder="tu@email.com"
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Tipo de servicio *</label>
                <select
                  name="tipo_servicio"
                  required
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white cursor-pointer"
                >
                  <option value="">Selecciona...</option>
                  <option value="Casa">Limpieza de Casa</option>
                  <option value="Apartamento">Limpieza de Apartamento</option>
                  <option value="Oficina">Limpieza de Oficina</option>
                  <option value="Move In">Move In</option>
                  <option value="Move Out">Move Out</option>
                  <option value="Hotel">Limpieza de Hotel</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Frecuencia</label>
                <select
                  name="frecuencia"
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white cursor-pointer"
                >
                  <option value="">Selecciona...</option>
                  <option value="Semanal">Semanal</option>
                  <option value="Quincenal">Quincenal</option>
                  <option value="Mensual">Mensual</option>
                  <option value="Servicio Único">Servicio Único</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Dirección del servicio</label>
              <input
                type="text"
                name="direccion"
                placeholder="Ej: 123 Main St, Jacksonville, FL"
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Detalles adicionales</label>
              <textarea
                name="mensaje"
                rows={4}
                maxLength={500}
                placeholder="Número de habitaciones, baños, necesidades especiales..."
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 bg-white resize-none"
                onChange={(e) => setCharCount(e.target.value.length)}
              ></textarea>
              <div className="text-xs text-gray-400 text-right mt-1">{charCount}/500</div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="bg-teal-500 hover:bg-teal-600 disabled:opacity-60 text-white font-bold py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 text-base"
            >
              {loading ? (
                <><i className="ri-loader-4-line animate-spin"></i> Enviando...</>
              ) : (
                <><i className="ri-send-plane-line"></i> Solicitar Cotización Gratis</>
              )}
            </button>

            <p className="text-xs text-gray-400 text-center">
              Sin compromiso. Te respondemos en menos de 24 horas con tu cotización personalizada.
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
